import { Button, Col, Form, Input, Row, Space, theme, Table, Select, Tooltip, message } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { FORMAT_DATE, HeaderTableCus } from '../../constants/constants';
import { SearchOutlined } from '@ant-design/icons';
import { filterOption, getSelectedBranch } from '../../utils/funcHelper';
import dayjs from 'dayjs';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { useSelector } from 'react-redux';
import { customer_services_detail, customer_services_update_status, employees_list, getListBranches, inactive_service_customers} from '../../services/apis';
import ServiceDetailModal from './modal/ServiceDetailModal';
import { isNumber } from 'lodash';

const ManagerRegisterServicesPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const initialValues = {
        date: [dayjs().startOf('day'), dayjs().endOf('day')],
        branch_id: getSelectedBranch() ? getSelectedBranch()?.id : null,
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [employees, setEmployees] = useState([]);
    const [isShowModalDetailService, setIsShowModalDetailService] = useState(false);
    const [dataPositions, setDataPositions] = useState([]);
    const [dataBranches, setDataBranches] = useState([]);
    const columns = [
        {
            title: 'STT',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div>{(currentPage - 1) * currentPageSize + index + 1}</div>,
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'service_name',
            key: 'service_name',
            width: 200,
            render: (text, record, index) => <div>
                <a style={{ paddingLeft: 0, paddingRight: 8 }}>{text}</a>
            </div>,
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            width: 200,
            render: (text, record, index) => <div
                style={{
                    paddingLeft: 0, paddingRight: 12, color: '#ff0000',
                }}>
                {text}
            </div>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Chi nhánh',
            dataIndex: 'branch_name',
            key: 'branch_name',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Ngày đăng ký',
            dataIndex: 'start_date',
            key: 'start_date',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{dayjs(text).format('DD-MM-YYYY')}</div>,
        },
        {
            title: 'Ngày hết hạn',
            dataIndex: 'end_date',
            key: 'end_date',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{text ? dayjs(text).format(FORMAT_DATE.DDMMYYYY) : 'Không thời hạn'}</div>,
        },
        {
            title: 'Ngày làm DV gần nhất',
            dataIndex: 'last_session_date',
            key: 'last_session_date',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{text ? dayjs(text).format('DD-MM-YYYY') : 'Chưa sử dụng'}</div>,
        },
        {
            title: 'Ngày hỗ trợ gần nhất',
            dataIndex: 'last_care_date',
            key: 'last_care_date',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{text ? dayjs(text).format('DD-MM-YYYY') : <span style={{color: 'red', fontStyle: 'italic'}}>Chưa hỗ trợ</span>}</div>,
        },
        {
            title: 'Số ngày chưa tới làm',
            dataIndex: 'days_since_last',
            key: 'days_since_last',
            width: 90,
            align: 'center',
            render: (text, record, index) => <div style={{color: 'red', fontWeight: 'bold'}}>{text}</div>,
        },
    ];
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const getDataServiceDetail = async (service_id) => {
        
        try {
            const params = {
                id: service_id,
            }
            setLoading(true);
            const res = await customer_services_detail(params);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setIsShowModalDetailService(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }
        
    }


    const getDataCustomerSupport = async (page, showLoading, pageSize) => {
        try {
            const params = {
                days: isNumber(parseInt(form.getFieldValue('days'))) ? form.getFieldValue('days') : null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                page: page ?? currentPage,
                limit: pageSize ?? currentPageSize,
            }
            if (showLoading) setLoading(true);
            const res = await inactive_service_customers(params);
            if (showLoading) setLoading(false);
            consoleLogUtil("res inactive_service_customers", res);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            
        }
    }

    const getDataEmployees = async (keyword) => {
        try {
            const params = {
                keyword: keyword,
                branch_id: null,
                limit: 100,
                currentPage: 1,
            }
            const res = await employees_list(params);
            if (res && res.status === 1) {
                setEmployees([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.full_name }))]);
            } else {
                setEmployees([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const onFinish = async (dataForm) => {
        setCurrentPage(1);
        getDataCustomerSupport(1, true);
    };

    const handleSaveServiceDetail = async (data) => {
        try {
            const params = {
                id: data?.id,
                status: data?.status,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await customer_services_update_status(params);
            if (res && res.status === 1) {
                message.success('Cập nhật dịch vụ thành công');
                getDataCustomerSupport(1, true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }
    }

    const getDataBranches = async () => {
            try {
                const params = {
                    keyword: '',
                }
                const res = await getListBranches(params);
                if (res && res.status === 1) {
                    setDataBranches([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
                } else {
                    setDataBranches([]);
                }
            } catch (error) {
                setLoading(false);
                console.log('error', error);
            }
            
    
        }
    
    useEffect(() => {
        setLoading(true);
        Promise.all([getDataEmployees(), getDataBranches()]).finally(() => setLoading(false));
    }, [])

    useEffect(() => {
        if (form) {
            form.setFieldsValue(initialValues);
            getDataCustomerSupport(1, true)
        }
    }, [form, dataBranches])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'days'}
                        >
                            <Input 
                                placeholder={'Nhập số ngày khách chưa tới làm'} 
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataBranches}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={2}>
                        <Space size="small">
                            <Tooltip title="Tìm kiếm">
                                <Button 
                                    type="primary" 
                                    htmlType="submit"
                                    className='custom-input-antd'
                                >
                                    <SearchOutlined /> Lọc khách hàng
                                </Button>
                            </Tooltip>

                        </Space>
                    </Col>
                </Row>
            </Form>
            
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                bordered
                rowKey={(record) => record?.customer_service_id}
                scroll={{ x: 'max-content'}}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            getDataServiceDetail(record?.customer_service_id);
                        }, // click row
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataCustomerSupport(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} khách hàng`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataCustomerSupport(1, true, size);
                    }
                }}
            />

            <ServiceDetailModal 
                visible={isShowModalDetailService}
                onClose={() => setIsShowModalDetailService(false)}
                data={itemSelected}
                employees={employees}
                positions={dataPositions}
                onSave={handleSaveServiceDetail}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ManagerRegisterServicesPage);